import { print } from 'graphql';

import { findByIdCompanyQuery } from '~/shared/graphql-queries/companies';
import removeByIdCompanyMutation from '~/shared/graphql-queries/companies/remove-by-id-company-mutation';
import updateByIdCompanyMutation from '~/shared/graphql-queries/companies/update-by-id-company-mutation';
import type { BuilderType } from '~/types';

type RemoveByIdCompanyArgs = Readonly<{
  _id?: string;
}>;

type UpdateByIdCompanyArgs = Readonly<{
  _id?: string;
  record?: Record<string, unknown>;
}>;

type FindByIdCompanyArgs = Readonly<{
  _id?: string;
}>;

export const companiesTagTypes = [] as const;

export const getCompaniesQuery = (builder: BuilderType) => {
  return {
    removeByIdCompany: builder.mutation<unknown, RemoveByIdCompanyArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(removeByIdCompanyMutation),
          variables: {
            _id: args?._id,
          },
        }),
      }),
    }),

    updateByIdCompany: builder.mutation<unknown, UpdateByIdCompanyArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(updateByIdCompanyMutation),
          variables: {
            _id: args?._id,
            record: args?.record,
          },
        }),
      }),
    }),

    findByIdCompany: builder.query<unknown, FindByIdCompanyArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(findByIdCompanyQuery),
          variables: {
            _id: args?._id,
          },
        }),
      }),
    }),
  };
};
